<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division">
<h1 class="chapter4b"><strong>CONTENTS</strong></h1>
<p class="nonindent4"><a class="hlink" href="#/Text/9781454919667_epub_c01_r1">  1    “You Are a Complete Disappointment”</a></p>
<p class="nonindent4"><a class="hlink" href="#/Text/9781454919667_epub_c02_r1">  2    Of Atomic FireBalls<sup>®</sup> and Talking Cows</a></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c03_r1" title="Link target outside of Sample">  3    The Great Meatball Pizza Incident</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c04_r1" title="Link target outside of Sample">  4    Welcome to the Summer of Suck</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c05_r1" title="Link target outside of Sample">  5    How to Win Friends and Influence Idiots</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c06_r1" title="Link target outside of Sample">  6    “You Built a Computer When You Were Eight, and Then… Nothing!!”</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c07_r1" title="Link target outside of Sample">  7    Papa Joe</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c08_r1" title="Link target outside of Sample">  8    Requiem</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c09_r1" title="Link target outside of Sample">  9    Punching Back</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c10_r1" title="Link target outside of Sample">10    (Talkin’ ’Bout) My GGGGeneration</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c11_r1" title="Link target outside of Sample">11    Brothers and Sisters</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c12_r1" title="Link target outside of Sample">12    Mom</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c13_r1" title="Link target outside of Sample">13    From Mauler to Mahler</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c14_r1" title="Link target outside of Sample">14    I Am Just a Jeepster for Your Love</span></p>
<p class="nonindent4"><span class="hlink" href="#/Text/9781454919667_epub_c15_r1" title="Link target outside of Sample">15    Freedom</span></p>
<p class="nonindent4a"><span class="hlink" href="#/Text/9781454919667_epub_ack_r1" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="nonindent4b"><span class="hlink" href="#/Text/9781454919667_epub_ata_r1" title="Link target outside of Sample"><em>About the Author</em></span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454919667_epub_toc_r1.vue?1791a8d1